module.exports = __webpack_public_path__ + "img/LADBROKES.8e3f037d.svg";